module.exports = __webpack_public_path__ + "static/media/pdf_download_black.9442ea2d.png";